import { OurLocationMapProps } from '@petconsole/pure-fe-map';
import { LazyLoad /*, LazyProp */ } from '../../lazy';

// const OurLazyEntitiesMap = LazyLoad((() => import('./OurLazyEntitiesMap')) as LazyProp);
const OurLazyLocationMap = LazyLoad<OurLocationMapProps>((() => import('./OurLazyLocationMap')));
const OurLazyMemberMap = LazyLoad(() => import('./OurLazyMemberMap'));

export { /* OurLazyEntitiesMap, */ OurLazyLocationMap, OurLazyMemberMap };